var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-wrapper" }, [
    _c("div", { staticClass: "order-title" }, [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.$t("trade." + _vm.orderType + ".title", {
              token: _vm.ftokenShow
            })
          ) +
          "\n        "
      ),
      _c("div", { staticClass: "wallet" }, [
        _vm._v(
          "\n            " + _vm._s(_vm.balance || "0") + "\n            "
        ),
        _c("span", { staticClass: "ex-order-token" }, [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.orderType === "buy" ? _vm.ttokenShow : _vm.ftokenShow
              ) +
              "\n            "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dex-input-wrapper b" }, [
      _c("span", { staticClass: "ex-order-token __ellipsis" }, [
        _vm._v(
          "\n            " +
            _vm._s(
              _vm.$t("trade." + _vm.orderType + ".price", {
                token: _vm.originQuoteTokenSymbol
              })
            ) +
            "\n        "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "else-input-wrapper", class: { err: _vm.priceErr } },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.focusInput === "price" && _vm.priceErr,
                  expression: "focusInput === 'price' && priceErr"
                }
              ],
              staticClass: "tips"
            },
            [_vm._v(_vm._s(_vm.priceErr || ""))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowBuyMining,
                  expression: "isShowBuyMining"
                }
              ],
              staticClass: "tips"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$t("tradeCenter.buyMiningPrice", {
                      price: _vm.buyMiningPrice
                    })
                  ) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowSellMining,
                  expression: "isShowSellMining"
                }
              ],
              staticClass: "tips"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$t("tradeCenter.sellMiningPrice", {
                      price: _vm.sellMiningPrice
                    })
                  ) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "vite-input",
            {
              attrs: {
                type: "number",
                step: this.$store.getters.quoteTokenStepLimit
              },
              on: {
                input: _vm.priceChanged,
                focus: function($event) {
                  return _vm.showTips("price")
                },
                blur: function($event) {
                  return _vm.hideTips("price")
                }
              },
              model: {
                value: _vm.price,
                callback: function($$v) {
                  _vm.price = $$v
                },
                expression: "price"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "real-price __ellipsis",
                  attrs: { slot: "after" },
                  slot: "after"
                },
                [_vm._v(_vm._s(_vm.realPrice))]
              )
            ]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dex-input-wrapper" }, [
      _c("span", { staticClass: "ex-order-token __ellipsis" }, [
        _vm._v(
          "\n            " +
            _vm._s(
              _vm.$t("trade." + _vm.orderType + ".quantity", {
                token: _vm.originTradeTokenSymbol
              })
            ) +
            "\n        "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "else-input-wrapper", class: { err: _vm.quantityErr } },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.focusInput === "quantity" && _vm.quantityErr,
                  expression: "focusInput === 'quantity' && quantityErr"
                }
              ],
              staticClass: "tips"
            },
            [_vm._v(_vm._s(_vm.quantityErr))]
          ),
          _vm._v(" "),
          _c("vite-input", {
            attrs: {
              type: "number",
              step: this.$store.getters.tradeTokenStepLimit
            },
            on: {
              input: _vm.quantityChanged,
              focus: function($event) {
                return _vm.showTips("quantity")
              },
              blur: function($event) {
                return _vm.hideTips("quantity")
              }
            },
            model: {
              value: _vm.quantity,
              callback: function($$v) {
                _vm.quantity = $$v
              },
              expression: "quantity"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "slider-wrapper" },
      [
        _c("slider", {
          staticClass: "dex-order",
          class: _vm.orderType,
          attrs: { min: 0, max: 100, default: 0 },
          on: { drag: _vm.percentChanged },
          model: {
            value: _vm.percent,
            callback: function($$v) {
              _vm.percent = $$v
            },
            expression: "percent"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "dex-input-wrapper" }, [
      _c("span", { staticClass: "ex-order-token __ellipsis" }, [
        _vm._v(
          "\n            " +
            _vm._s(
              _vm.$t("trade.quantityTitle", {
                quantity: _vm.originQuoteTokenSymbol
              })
            ) +
            "\n        "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "else-input-wrapper", class: { err: _vm.amountErr } },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.focusInput === "amount" && _vm.amountErr,
                  expression: "focusInput === 'amount' && amountErr"
                }
              ],
              staticClass: "tips"
            },
            [_vm._v(_vm._s(_vm.amountErr))]
          ),
          _vm._v(" "),
          _c("vite-input", {
            attrs: {
              type: "number",
              step: this.$store.getters.quoteTokenStepLimit
            },
            on: {
              input: _vm.amountChanged,
              focus: function($event) {
                return _vm.showTips("amount")
              },
              blur: function($event) {
                return _vm.hideTips("amount")
              }
            },
            model: {
              value: _vm.amount,
              callback: function($$v) {
                _vm.amount = $$v
              },
              expression: "amount"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.isLogin
      ? _c(
          "div",
          {
            staticClass: "order-btn __pointer",
            class: {
              red: _vm.orderType === "sell",
              green: _vm.orderType === "buy",
              gray:
                _vm.isLoading ||
                _vm.amountErr ||
                _vm.priceErr ||
                _vm.quantityErr ||
                _vm.activeTxPairIsClose
            },
            on: { click: _vm._clickBtn }
          },
          [
            _vm._v(
              _vm._s(
                _vm.$t("trade." + _vm.orderType + ".title", {
                  token: _vm.ftokenShow
                })
              )
            )
          ]
        )
      : _c(
          "div",
          {
            staticClass: "order-btn __pointer",
            class: {
              red: _vm.orderType === "sell",
              green: _vm.orderType === "buy"
            }
          },
          [
            _vm.isHaveUsers
              ? _c("span", [
                  _c("span", { on: { click: _vm.unlock } }, [
                    _vm._v(_vm._s(_vm.$t("unlockAcc")))
                  ]),
                  _vm._v(" / "),
                  _c("span", { on: { click: _vm.login } }, [
                    _vm._v(_vm._s(_vm.$t("changeAcc")))
                  ])
                ])
              : _c("span", [
                  _c("span", { on: { click: _vm.login } }, [
                    _vm._v(_vm._s(_vm.$t("login")))
                  ]),
                  _vm._v(" / "),
                  _c("span", { on: { click: _vm.login } }, [
                    _vm._v(_vm._s(_vm.$t("register")))
                  ])
                ])
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }